export const selectLocation = (state) => state.location

/**
 * @typedef Location
 * @property {String} hostname
 * @property {Object} query
 * @property {String} search
 * @property {String|null} hash
 * @property {String} pathname
 * @property {String} path
 * @property {String} href
 */

/**
 * @param {Object} state
 * @return {Location}
 */
export const selectLocationPathname = (state) => state.location.getIn(['data', 'pathname'], '')
